import { render, staticRenderFns } from "./DSReCaptcha.vue?vue&type=template&id=6af83b3e&"
import script from "./DSReCaptcha.vue?vue&type=script&lang=js&"
export * from "./DSReCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./DSReCaptcha.vue?vue&type=style&index=0&id=6af83b3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports